module.exports = __webpack_public_path__ + "static/media/detail_title_yx.c5748a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/detail_title_yx.png
// module id = 339
// module chunks = 4